
export var geographies = {};

geographies['ak'] = require('./ocd-division/country/us/state/ak/shape');
geographies['al'] = require('./ocd-division/country/us/state/al/shape');
geographies['ar'] = require('./ocd-division/country/us/state/ar/shape');
geographies['as'] = require('./ocd-division/country/us/state/as/shape');
geographies['az'] = require('./ocd-division/country/us/state/az/shape');
geographies['ca'] = require('./ocd-division/country/us/state/ca/shape');
geographies['co'] = require('./ocd-division/country/us/state/co/shape');
geographies['ct'] = require('./ocd-division/country/us/state/ct/shape');
geographies['dc'] = require('./ocd-division/country/us/state/dc/shape');
geographies['de'] = require('./ocd-division/country/us/state/de/shape');
geographies['fl'] = require('./ocd-division/country/us/state/fl/shape');
geographies['ga'] = require('./ocd-division/country/us/state/ga/shape');
geographies['du'] = require('./ocd-division/country/us/state/gu/shape');
geographies['hi'] = require('./ocd-division/country/us/state/hi/shape');
geographies['ia'] = require('./ocd-division/country/us/state/ia/shape');
geographies['id'] = require('./ocd-division/country/us/state/id/shape');
geographies['il'] = require('./ocd-division/country/us/state/il/shape');
geographies['in'] = require('./ocd-division/country/us/state/in/shape');
geographies['ks'] = require('./ocd-division/country/us/state/ks/shape');
geographies['ky'] = require('./ocd-division/country/us/state/ky/shape');
geographies['la'] = require('./ocd-division/country/us/state/la/shape');
geographies['ma'] = require('./ocd-division/country/us/state/ma/shape');
geographies['md'] = require('./ocd-division/country/us/state/md/shape');
geographies['me'] = require('./ocd-division/country/us/state/me/shape');
geographies['mi'] = require('./ocd-division/country/us/state/mi/shape');
geographies['mn'] = require('./ocd-division/country/us/state/mn/shape');
geographies['mo'] = require('./ocd-division/country/us/state/mo/shape');
geographies['mp'] = require('./ocd-division/country/us/state/mp/shape');
geographies['ms'] = require('./ocd-division/country/us/state/ms/shape');
geographies['mt'] = require('./ocd-division/country/us/state/mt/shape');
geographies['nc'] = require('./ocd-division/country/us/state/nc/shape');
geographies['nd'] = require('./ocd-division/country/us/state/nd/shape');
geographies['ne'] = require('./ocd-division/country/us/state/ne/shape');
geographies['nh'] = require('./ocd-division/country/us/state/nh/shape');
geographies['nj'] = require('./ocd-division/country/us/state/nj/shape');
geographies['nm'] = require('./ocd-division/country/us/state/nm/shape');
geographies['nv'] = require('./ocd-division/country/us/state/nv/shape');
geographies['ny'] = require('./ocd-division/country/us/state/ny/shape');
geographies['oh'] = require('./ocd-division/country/us/state/oh/shape');
geographies['ok'] = require('./ocd-division/country/us/state/ok/shape');
geographies['or'] = require('./ocd-division/country/us/state/or/shape');
geographies['pa'] = require('./ocd-division/country/us/state/pa/shape');
geographies['pr'] = require('./ocd-division/country/us/state/pr/shape');
geographies['ri'] = require('./ocd-division/country/us/state/ri/shape');
geographies['sc'] = require('./ocd-division/country/us/state/sc/shape');
geographies['sd'] = require('./ocd-division/country/us/state/sd/shape');
geographies['tn'] = require('./ocd-division/country/us/state/tn/shape');
geographies['tx'] = require('./ocd-division/country/us/state/tx/shape');
geographies['ut'] = require('./ocd-division/country/us/state/ut/shape');
geographies['va'] = require('./ocd-division/country/us/state/va/shape');
geographies['vi'] = require('./ocd-division/country/us/state/vi/shape');
geographies['vt'] = require('./ocd-division/country/us/state/vt/shape');
geographies['wa'] = require('./ocd-division/country/us/state/wa/shape');
geographies['wi'] = require('./ocd-division/country/us/state/wi/shape');
geographies['wv'] = require('./ocd-division/country/us/state/wv/shape');
geographies['wy'] = require('./ocd-division/country/us/state/wy/shape');
